module.exports = __webpack_public_path__ + "static/media/baseline-email-24px.daba9a53.svg";